import equal from 'fast-deep-equal/es6/react';

// Get an array of unique key values from an array of objects
export const uniqueValuesFromObjectArray = (arr, key) => {
  return [...new Set(arr.map(item => item[key]))];
};

// Above but for ID values (used for POST/PATCH to API)
export const taxonomyListToIdArray = (arr) => {
  return uniqueValuesFromObjectArray(arr, 'id');
};

// This function converts data from a taxonomy tree format to a flat list
// of ID's. This is needed for components that allw editing of the taxonomy
// items linked to an object (e.g. a provider).
//
// This is used with API GET responses for taxonomy items which come as:
//  [{"id": 1, "name": "parent", "children": [
//       {"id": 7, "name": "child", ...{}
//  ], ...{}]
//
// API POST/PATCH inputs for taxonomy items require an ID list like:
// [1, 3, 5, 6, ...]
//
export const taxonomyTreeToIdArray = (tree) => {
  const ids = tree.map(item => uniqueValuesFromObjectArray(item.children, 'id'));
  return ids.flat();
};

export const taxonomyItemId = (itemName, taxonomy) => {
  let result = null;
  taxonomy.forEach(parent => {
    parent.children.forEach(child => {
      if (child.name === itemName) {
        result = parseInt(child.id);
      }
    });
  });
  return result;
};

// Convert an array of objects to a structured array with category as key
// and list of subcategories for each key
export const objectArrayToStructuredObject = (arr, key, subkey) => {
  let uniqueKeys = uniqueValuesFromObjectArray(arr, key);
  let structured = uniqueKeys.map(keyItem => {
    let newObj = {};
    let keyArray = arr.filter(item => item[key] === keyItem);
    let uniqueSubkeys = uniqueValuesFromObjectArray(keyArray, subkey);
    newObj[key] = keyItem;
    newObj[subkey] = uniqueSubkeys;
    return newObj;
  });
  return structured;
};

export const formatComponentId = (prefix, label) => {
  const formattedLabel = label.replace(/\s+/g, '-').toLowerCase();
  return `${prefix}-${formattedLabel}`;
};

// Deep-compare two objects to create a new object which contains only
// the difference between the latest and the initial object. This is useful
// for API update processes where we want to submit only data that has changed
// via a PATCH request to avoid errors such as trying to update a linked
// attribute.
export const dataDiff = (initial, latest) => {
  const result = {};
  Object.keys(latest).forEach(k => {
    if (!equal(latest[k], initial[k])) {
      result[k] = latest[k];
    }
  });
  return result;
};

// Finds an item in an array by value of a specified attribute
// Useful for converting ID values from pickers to name values from taxonomies
// and vice versa
export const itemFromArray = (arr, field, value) => {
  return arr.find(v => v[field] === value);
};
